var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"/_nuxt_home_page/general/facebook.svg","loading":"lazy","alt":"facebook","width":"24","height":"24"}})
}
var staticRenderFns = []

export { render, staticRenderFns }